import React from 'react';
export function CancellationPolicy() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-slate-50" data-id="element-168">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-169">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-170">
          Cancellation Policy
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6" data-id="element-171">
          <div data-id="element-172">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-173">
              Your Right to Cancel
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-174">
              At Domisafe, we want you to be completely satisfied with our
              service. We understand that circumstances change, and we've
              designed our cancellation policy to be fair and transparent.
            </p>
          </div>

          <div data-id="element-175">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-176">
              14-Day Cancellation Window
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-177">
              You have the right to cancel your subscription within 14 days of
              your initial purchase if you have not used the service. This
              cooling-off period allows you to change your mind without penalty.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-178">
              To qualify for a full refund during this period, you must not have
              accessed or used any features of the Domisafe platform. If you
              have logged in and begun using the service, the cancellation may
              still be processed, but refund eligibility will be assessed on a
              case-by-case basis.
            </p>
          </div>

          <div data-id="element-179">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-180">
              Cancellation After 14 Days
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-181">
              You may cancel your subscription at any time after the initial
              14-day period. However, cancellations made after this window might
              not qualify for a refund, depending on your usage of the service
              and the timing of your cancellation.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-182">
              When you cancel after 14 days, your access to Domisafe will
              continue until the end of your current billing period. You will
              not be charged for subsequent months, but no refund will be issued
              for the current billing cycle unless exceptional circumstances
              apply.
            </p>
          </div>

          <div data-id="element-183">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-184">
              How to Cancel
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-185">
              To cancel your subscription, please contact our support team via
              email at{' '}
              <a href="mailto:srijangurung098@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-186">
                srijangurung098@gmail.com
              </a>
              . Include your account details and the reason for cancellation
              (optional but helpful for improving our service).
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-187">
              We aim to process all cancellation requests within one working
              day. You will receive a confirmation email once your cancellation
              has been completed.
            </p>
          </div>

          <div data-id="element-188">
            <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-189">
              Important Notes
            </h3>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-190">
              <li data-id="element-191">Cancellations must be requested in writing via email</li>
              <li data-id="element-192">
                Refunds, where applicable, are processed according to our Refund
                Policy
              </li>
              <li data-id="element-193">
                Data associated with your account may be retained for a limited
                period as per our Privacy Policy
              </li>
              <li data-id="element-194">
                You may reactivate your subscription at any time by contacting
                our team
              </li>
            </ul>
          </div>

          <div className="bg-slate-50 rounded-lg p-6 mt-8" data-id="element-195">
            <p className="text-slate-700 leading-relaxed" data-id="element-196">
              <span className="font-semibold" data-id="element-197">
                Questions about cancellation?
              </span>{' '}
              Our support team is here to help. Contact us at{' '}
              <a href="mailto:srijangurung098@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-198">
                srijangurung098@gmail.com
              </a>{' '}
              and we'll respond within one working day.
            </p>
          </div>
        </div>
      </section>
    </div>;
}